import React, { useState } from "react";
import BackIcon from "../../Assets/Icons/BackIcon";
import "./basketball.css";

import basket_trainer from "../../Assets/Images/Basketball/basket_trainer.png";
import basket_trainer2 from "../../Assets/Images/Basketball/basket_trainer2.png";
import basketball_banner from "../../Assets/Images/Basketball/basketball_banner.png";
import basketball_section from "../../Assets/Images/Basketball/basketball_section.png";
import basketball_section2 from "../../Assets/Images/Basketball/basketball_section2.png";
import basketball_skill1 from "../../Assets/Images/Basketball/basketball_skill1.png";
import basketball_skill2 from "../../Assets/Images/Basketball/basketball_skill2.png";
import basketball_skill3 from "../../Assets/Images/Basketball/basketball_skill3.png";
import basketball_skill4 from "../../Assets/Images/Basketball/basketball_skill4.png";
import basketball_skill5 from "../../Assets/Images/Basketball/basketball_skill5.png";
import basketball1 from "../../Assets/Images/Basketball/basketball1.png";
import basketball2 from "../../Assets/Images/basketball2.png";
import basketball3 from "../../Assets/Images/Basketball/basketball3.png";
import basketball4 from "../../Assets/Images/Basketball/basketball4.png";

import basketball_trainer2 from "../../Assets/Images/basketball_trainer2.png";
import { useNavigate } from "react-router-dom";
import SEO from "../../Components/SEO";

export default function Basketball() {
  const navigate = useNavigate();
  const user = JSON.parse(localStorage.getItem("user"));
  const handleSubmit = (type) => {
    if (user && user.is_self_pay === false && type) {
      navigate(`/list-of-sports?type=${type}`);
    } else if (user && user.is_self_pay === true && type) {
      navigate(`/session-sports?type=${type}`);
    } else {
      navigate(`/create-an-account`);
    }
  };

  const redirectTo = (url) => {
    window.location.href = url;
  };
  return (
    <>
      <SEO
        title="Instruction | Basketball | BWC Sports"
        description=""
        url="https://bwcsports.com/instruction/basketball"
      />
      <div className="basketball-container">
        <div className="basketball-header filter-brightness">
          <div className="base-sec">
            <div>
              <span className="basketball-backIcon">
                <BackIcon />
              </span>
            </div>
            <div className="basketball-header-content">
              <h1 className="black-text-clip">Basketball</h1>
              <h3 className="black-text-clip">
                WANT TO TAKE YOUR BASKETBALL GAME TO THE NEXT LEVEL?
              </h3>
              <p className="black-text-clip">
                Our skilled basketball trainer offers customized lessons for
                players of all ages and abilities. Whether you’re just starting
                out or looking to sharpen your skills, our sessions focus on
                fundamental techniques, game strategies, and physical
                conditioning. Learn dribbling, shooting, passing, defense, and
                more in a supportive and encouraging environment. Join us to
                enhance your performance, build confidence, and excel on the
                court. Sign up today and start your journey to basketball
                greatness!
              </p>
            </div>
          </div>
        </div>
        <div className="basketball-booking-container">
          <button
            className="one-on-one-dif"
            onClick={() => handleSubmit("1-1")}
            // onClick={() => redirectTo("https://docs.google.com/forms/d/e/1FAIpQLSfic6TWwwnrFXBuxpvLrfmzXW3myU7jKjYLO8hFNQ9jJRpI0A/viewform")}

            style={{ cursor: "pointer" }}
          >
            <span className="black-text-clip">Schedule 1-on-1 Class Here</span>
          </button>
          <button
            className="one-on-one-dif"
            onClick={() => handleSubmit("Group")}
            // onClick={() => redirectTo("https://docs.google.com/forms/d/e/1FAIpQLSfic6TWwwnrFXBuxpvLrfmzXW3myU7jKjYLO8hFNQ9jJRpI0A/viewform")}

            style={{ cursor: "pointer" }}
          >
            <span className="black-text-clip">Schedule Group Class Here</span>
          </button>
          {!user && (
            <button
              className="one-on-one basketball-booking-selected"
              onClick={() => handleSubmit("")}
            // onClick={() => redirectTo("https://docs.google.com/forms/d/e/1FAIpQLSfic6TWwwnrFXBuxpvLrfmzXW3myU7jKjYLO8hFNQ9jJRpI0A/viewform")}

              style={{ cursor: "pointer" }}
            >
              <span className="black-text-clip">Sign Up for Classes Here</span>
            </button>
          )}
        </div>
        <div className="basketball-image-container">
          <img src={basketball4} alt="basketball-image" />
          <img src={basketball2} alt="basketball-image" />
          <img src={basketball3} alt="basketball-image" />
          <img src={basketball1} alt="basketball-image" />
        </div>
        <div className="basketball-section2">
          <h3 className="black-text-clip">Why Choose BWC Basketball?</h3>
          <p className="black-text-clip">
            At BWC Basketball, we offer a range of programs that are as
            comprehensive as they are fun. Our goal is to provide every player
            with the tools they need to succeed, both on and off the court. Our
            carefully designed drills and games create an environment where
            learning is exciting and improvement is inevitable.
          </p>
          <div className="basketball-section2-image-container">
            <span className="basketball-overlay-text bottom-left">
              1-on-1 Training
            </span>
            <span className="basketball-overlay-text top-right bask-right">
              Group Training
            </span>
            <img src={basketball_section2} alt="basketball-image-session" />
          </div>
        </div>

        <div className="basketball-section3">
          <h3 className="black-text-clip">Dive into Our Exciting Programs</h3>
          <p className="black-text-clip">
            Our programs are packed with a variety of drills and games designed
            to sharpen your skills and boost your confidence:
          </p>
          <div className="basketball-inner-section3">
            <div className="bb-card">
              <img src={basketball_skill5} alt="Dribbling" />
              <div className="bb-card-content">
                <div className="bb-card-title">Dribbling</div>
                <div className="bb-card-desc">
                  Develop ball-handling skills to maintain control while moving
                  on the court.
                </div>
              </div>
            </div>

            <div className="bb-card">
              <img src={basketball_skill4} alt="Shooting" />
              <div className="bb-card-content">
                <div className="bb-card-title">Shooting</div>
                <div className="bb-card-desc">
                  Focus on perfecting shooting form, release, and
                  follow-through.
                </div>
              </div>
            </div>

            <div className="bb-card">
              <img src={basketball_skill3} alt="Passing" />
              <div className="bb-card-content">
                <div className="bb-card-title">Passing</div>
                <div className="bb-card-desc">
                  Work on chest passes, bounce passes, and overhead passes to
                  improve court vision and teamwork.
                </div>
              </div>
            </div>

            <div className="bb-card">
              <img src={basketball_skill2} alt="Defense" />
              <div className="bb-card-content">
                <div className="bb-card-title">Defense</div>
                <div className="bb-card-desc">
                  Train on defensive positioning, footwork, and lateral
                  movements to stay in front of your opponent.
                </div>
              </div>
            </div>

            <div className="bb-card">
              <img src={basketball_skill1} alt="Rebounding" />
              <div className="bb-card-content">
                <div className="bb-card-title">Rebounding</div>
                <div className="bb-card-desc">
                  Improve timing and positioning to secure offensive and
                  defensive rebounds.
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="basketball-section4">
          <h3 className="black-text-clip">Scrimmages and Games</h3>
          <p className="black-text-clip">
            Practice makes perfect, but nothing beats game day. Our scrimmages
            and games give players the chance to apply what they’ve learned in a
            real-game setting, building confidence and experience. We cater to
            all skill levels, from ages 4 to 18, ensuring that every player
            finds their place on the field.
          </p>
        </div>
        <div className="basketball-booking-container2">
          <div className="basketball-booking-container-details">
            <h3 className="black-text-clip">READY TO GET STARTED?</h3>
            <p className="black-text-clip">
              Don’t miss out on this incredible opportunity to give your child
              the best start in basketball. Our spots fill up fast—secure your
              place today!
            </p>
            <p className="black-text-clip">
              <strong>Sign Up Now</strong> – Empower your child to succeed on
              and off the court.
            </p>
          </div>
          <div
            id="inside-booking-container"
            className="basketball-booking-container"
          >
            <button
              onClick={() => handleSubmit("1-1")}
            // onClick={() => redirectTo("https://docs.google.com/forms/d/e/1FAIpQLSfic6TWwwnrFXBuxpvLrfmzXW3myU7jKjYLO8hFNQ9jJRpI0A/viewform")}

              className="one-on-one-dif"
            >
              <span className="black-text-clip">
                Schedule 1-on-1 Class Here
              </span>
            </button>
            <button
              onClick={() => handleSubmit("Group")}
              className="one-on-one-dif"
            >
              <span className="black-text-clip">Schedule Group Class Here</span>
            </button>
            {!user && (
              <button
                className="one-on-one-diff"
                onClick={() => handleSubmit("")}
            // onClick={() => redirectTo("https://docs.google.com/forms/d/e/1FAIpQLSfic6TWwwnrFXBuxpvLrfmzXW3myU7jKjYLO8hFNQ9jJRpI0A/viewform")}

                style={{ background: "#FFB04F" }}
              >
                <span className="black-text-clip">
                  Sign Up for Classes Here
                </span>
              </button>
            )}
          </div>
        </div>
        <div className="basketball-booking-container outside-booking-container">
          <button className="one-on-one-diff">
            <span className="black-text-clip">Schedule 1-on-1 Class Here</span>
          </button>
          <button className="one-on-one-diff">
            <span className="black-text-clip">Schedule Group Class Here</span>
          </button>
          {!user && (
            <button
              onClick={() => handleSubmit("")}
            // onClick={() => redirectTo("https://docs.google.com/forms/d/e/1FAIpQLSfic6TWwwnrFXBuxpvLrfmzXW3myU7jKjYLO8hFNQ9jJRpI0A/viewform")}

              className="one-on-one-diff basketball-booking-selected"
            >
              <span className="black-text-clip">Sign Up for Classes Here</span>
            </button>
          )}
        </div>

        <div className="basketball-trainers">
          <h3 className="black-text-clip text-center">Our Trainers</h3>
          <div className="basketball-trainer-image-container">
            <div className="basketball-trainer-image">
              <div className="skill-text-overlay">
                <h4>Eric Wiese</h4>
                <p>Head Trainer</p>
              </div>
              <img src={basket_trainer2} alt="trainer-image" />
            </div>
            <div className="basketball-trainer-image">
              <div className="skill-text-overlay">
                <h4>Logan Daly</h4>
                <p>Head Trainer</p>
              </div>
              <img src={basketball_trainer2} alt="trainer-image" />
            </div>
            <div className="basketball-trainer-image">
              <div className="skill-text-overlay">
                <h4>Vin D’Acunto</h4>
                <p>Head Trainer</p>
              </div>
              <img src={basket_trainer} alt="trainer-image" />
            </div>
          </div>
        </div>
        <div className="basketball-locations">
          <h3 className="black-text-clip text-center">Locations</h3>
          <div className="basketball-location-container">
            <div className="card">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3033.5350871634496!2d-74.2432518!3d40.5076626!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89c3ca98eebc602d%3A0xb0ac61038153a3f9!2s528%20Academy%20Ave%2C%20Staten%20Island%2C%20NY%2010307%2C%20USA!5e0!3m2!1sen!2sin!4v1773669454739!5m2!1sen!2sin"
                allowfullscreen=""
                loading="lazy"
                referrerpolicy="no-referrer-when-downgrade"
              ></iframe>
              <div className="card-description black-text-clip">
                <p>
                  <strong>I.S. 34</strong>, New York
                </p>
              </div>
            </div>
            <div className="card">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3028.615905386927!2d-74.14155559999999!3d40.6162973!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89c24c3387658829%3A0x770465e3707ce954!2sChurch%20of%20the%20Holy%20Family%2C%20366%20Watchogue%20Rd%2C%20Staten%20Island%2C%20NY%2010314%2C%20USA!5e0!3m2!1sen!2sin!4v1773669716806!5m2!1sen!2sin"
                allowfullscreen=""
                loading="lazy"
                referrerpolicy="no-referrer-when-downgrade"
              ></iframe>
              <div className="card-description black-text-clip">
                <p>
                  <strong>Holy Family</strong>, New York
                </p>
              </div>
            </div>
            <div className="card">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3029.1620527858063!2d-74.13132175!3d40.6042481!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89c24c243f86c569%3A0x65ae2f33150032fc!2s281%20Bradley%20Ave%2C%20Staten%20Island%2C%20NY%2010314%2C%20USA!5e0!3m2!1sen!2sin!4v1773669747465!5m2!1sen!2sin"
                allowfullscreen=""
                loading="lazy"
                referrerpolicy="no-referrer-when-downgrade"
              ></iframe>
              <div className="card-description black-text-clip">
                <p>
                  <strong>St. Rita’s</strong>, New York
                </p>
              </div>
            </div>
            <div className="card">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3032.288499132894!2d-74.2398164!3d40.53521490000001!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89c3b53f9530b093%3A0x923a08def777405b!2s120%20Androvette%20St%2C%20Staten%20Island%2C%20NY%2010309%2C%20USA!5e0!3m2!1sen!2sin!4v1773669791594!5m2!1sen!2sin"
                allowfullscreen=""
                loading="lazy"
                referrerpolicy="no-referrer-when-downgrade"
              ></iframe>
              <div className="card-description black-text-clip">
                <p>
                  <strong>JUMPSHOTZ</strong>, New York
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
